import { render, staticRenderFns } from "./CheckoutReview.vue?vue&type=template&id=02251b1a&scoped=true&"
import script from "./CheckoutReview.vue?vue&type=script&lang=js&"
export * from "./CheckoutReview.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutReview.vue?vue&type=style&index=0&id=02251b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02251b1a",
  null
  
)

export default component.exports